import { SET_JE_USER_COOKIE } from '@/store/mutation.types';

export default {
    state: () => ({
        jeUserCookie: null
    }),

    actions: {
        setJeUserCookie: ({ commit }, cookieValue) => {
            commit(SET_JE_USER_COOKIE, cookieValue);
        }
    },

    mutations: {
        [SET_JE_USER_COOKIE]: (state, cookieValue) => {
            state.jeUserCookie = cookieValue;
        }
    }
};
